import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CalendarPlus, CalendarDays, Download } from "lucide-react";
import { googleCalendarUrl, downloadIcs } from "@/lib/calendar";

export function AddToCalendar({ opportunity, label = "Add to calendar", testid = "add-to-calendar", className = "", variant = "outline" }) {
  if (!opportunity?.event_date) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={testid} variant={variant} size="sm" className={`rounded-full border-fuchsia-200 text-fuchsia-700 hover:bg-fuchsia-50 ${className}`}>
          <CalendarPlus className="mr-1.5 h-4 w-4" /> {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuItem data-testid={`${testid}-google`} onClick={() => window.open(googleCalendarUrl(opportunity), "_blank", "noopener")}>
          <CalendarDays className="mr-2 h-4 w-4" /> Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-ics`} onClick={() => downloadIcs(opportunity)}>
          <Download className="mr-2 h-4 w-4" /> Apple / Outlook (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
